import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { messagingDiagnosticsCanvasStepsForFilter } from "./constants";
import type { MessagingDiagnosticsCanvasStepFilterResult } from "./types";

export const getMessagingDiagnosticsCanvasStepsForFilter = reactQueryFetcherAdapter(
  messagingDiagnosticsCanvasStepsForFilter,
  (
    signal: AbortSignal,
    appGroupId: string,
    query: string,
    limit: number,
    canvasIds: string[],
    // Empty string means "omit"; the adapter cache-key type excludes `undefined`.
    windowStart: string
  ): Promise<MessagingDiagnosticsCanvasStepFilterResult[]> => {
    return fetch(
      `/${appGroupId}/messaging_diagnostics/canvas_steps_for_filter`,
      "GET",
      {
        query,
        limit,
        canvas_ids: canvasIds,
        ...(windowStart ? { window_start: windowStart } : {}),
      },
      { signal }
    );
  }
);
